export default __webpack_public_path__ + "static/media/tile-grout.54ac7819.png";